import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';

const BookCarousel = ({ books, selectedBookId }) => {
    const { t } = useTranslation();

    const items = books.map(book => (
        <div key={book.id} className="item mx-10 mt-32">
            <Link to={`/books/${book.id}`} className="book-item">
                <img src={book.image_url} alt={book.title} />
                <h5>{book.title}</h5>
                <p>{book.authors}</p>
                <span>{book.price} zł</span>
            </Link>
        </div>
    ));

    return (
        <>
            {books.length === 0 && <p>No books available</p>}
            {books.length > 0 && (
                <AliceCarousel
                    mouseTracking
                    items={items}
                    autoPlay
                    autoPlayInterval={3000}
                    infinite
                    disableButtonsControls
                    responsive={{
                        0: { items: 1 },
                        600: { items: 2 },
                        1024: { items: 6 }, // Show 5 items at a time for larger screens
                    }}
                />
            )}
        </>
    );
};

export default BookCarousel; 